export default {
  matchingKeys: {
    id: 'bo_seller-options-batch_listing_creation-matching_keys',
    defaultMessage: 'Matching keys',
  },
  matchinKeysInfo: {
    id: 'bo_seller-options-batch_listing_creation-matching_keys_info',
    defaultMessage:
      'The matching key matches your listing with an item, you only need to provide one and can decide between backmarket_id or ean.',
  },
  columnName: {
    id: 'bo_seller-options-batch_listing_creation-column_name',
    defaultMessage: 'Column name',
  },
  format: {
    id: 'bo_seller-options-batch_listing_creation-format',
    defaultMessage: 'Format',
  },
  example: {
    id: 'bo_seller-options-batch_listing_creation-example',
    defaultMessage: 'Example',
  },
  mandatory: {
    id: 'bo_seller-options-batch_listing_creation-mandatory',
    defaultMessage: 'Mandatory',
  },
  optional: {
    id: 'bo_seller-options-batch_listing_creation-optional',
    defaultMessage: 'Optional',
  },
  allowedValues: {
    id: 'bo_seller.batch_listing_creation.allowed_values',
    defaultMessage: 'Allowed Values',
  },
  completeCsv: {
    id: 'bo_seller-options-batch_listing_creation-complete_csv',
    defaultMessage:
      'Complete the following fields for each listing you add in the CSV file.',
  },
  listingAttributes: {
    id: 'bo_seller-options-batch_listing_creation-listing_attributes',
    defaultMessage: 'Listing attributes',
  },
  productAttributes: {
    id: 'bo_seller-options-batch_listing_creation-product_attributes',
    defaultMessage: 'Product attributes',
  },
  shouldBeUniq: {
    id: 'bo_seller-options-batch_listing_creation-should_be_uniq',
    defaultMessage: '*You need only to provide one matching key.',
  },
  tipsTitle: {
    id: 'bo_seller-options-batch_listing_creation-tips_title',
    defaultMessage: 'Tips to keep in mind',
  },
  tipsContent: {
    id: 'bo_seller-options-batch_listing_creation-tips_content',
    defaultMessage:
      'All empty cells are ignored by default. If you want to erase a listing field, type “#CLEAR#” into the cell in the CSV file. For item descriptions or comments, you can only use the following HTML tags: < a >, < abbr >, < acronym >, < b >, < blockquote >, < code >, < em >, < i >, < li >, < ol >, < strong >, < ul >, < div >, < br >, and < p >. Other tags will be removed.',
  },
  actionRequiredTitle: {
    id: 'bo_seller-options-batch_listing_creation-action_required_title',
    defaultMessage: 'Action required',
  },
  actionRequiredContent: {
    id: 'bo_seller-options-batch_listing_creation-action_required_content_new',
    defaultMessage:
      'You chose item category {categoryName} for these listings of new items. The category_id is {categoryId}. Enter {categoryId} in the “category_id” column of your CSV file.',
  },
  exampleSku: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_sku',
    defaultMessage: 'IP6-64-SIL-B3',
  },
  exampleQuantity: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_quantity',
    defaultMessage: '10',
  },
  examplePrice: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_price',
    defaultMessage: '399.00',
  },
  exampleState: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_state',
    defaultMessage:
      '0: Super Shiny (perfect state), 1: Gold (as new), 2: Silver very good state), 3: Bronze (good state), 4: Stallone (correct)',
  },
  exampleWarrantyDelay: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_warranty_delay',
    defaultMessage: '12',
  },
  exampleComment: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_comment',
    defaultMessage: 'A comment here. Specific to the merchant and its offer.',
  },
  exampleCurrency: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_currency',
    defaultMessage: 'EUR',
  },
  exampleShipper1: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipper1',
    defaultMessage: 'UPS',
  },
  exampleShippingPrice1: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipping_price1',
    defaultMessage: '10.00',
  },
  exampleShippingDelay1: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipping_delay1',
    defaultMessage: '48',
  },
  exampleShipper2: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipper2',
    defaultMessage: '',
  },
  exampleShippingPrice2: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipping_price2',
    defaultMessage: '',
  },
  exampleShippingDelay2: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipping_delay2',
    defaultMessage: '',
  },
  exampleShipper3: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipper3',
    defaultMessage: '',
  },
  exampleShippingPrice3: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipping_price3',
    defaultMessage: '',
  },
  exampleShippingDelay3: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_shipping_delay3',
    defaultMessage: '',
  },
  exampleSnowden: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_snowden',
    defaultMessage: 'False',
  },
  exampleNoisyCamera: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_noisy_camera',
    defaultMessage: 'False',
  },
  exampleNewBattery: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_new_battery',
    defaultMessage: 'False',
  },
  exampleMinPrice: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_min_price',
    defaultMessage: '360.00',
  },
  exampleBackpricer: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_backpricer',
    defaultMessage: 'True',
  },
  exampleTitle: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_title',
    defaultMessage: '﻿iPhone 6 64 Go - Argent - Débloqué',
  },
  exampleDescription: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_description',
    defaultMessage:
      'A description here. Not specific to the merchant nor its offer but t the product.',
  },
  exampleBrand: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_brand',
    defaultMessage: 'Apple',
  },
  examplePriceNew: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_price_new',
    defaultMessage: '499.00',
  },
  exampleWeight: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_weight',
    defaultMessage: '129',
  },
  exampleImage1: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_image1',
    defaultMessage: 'http://www.apple.com/uploads/2015/10/KC009B.jpg',
  },
  exampleImage2: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_image2',
    defaultMessage: '',
  },
  exampleImage3: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_image3',
    defaultMessage: '',
  },
  exampleImage4: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_image4',
    defaultMessage: '',
  },
  exampleImage5: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_image5',
    defaultMessage: '',
  },
  exampleImage6: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_image6',
    defaultMessage: '',
  },
  exampleWidth: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_width',
    defaultMessage: '6.7',
  },
  exampleHeight: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_height',
    defaultMessage: '13.8',
  },
  exampleDepth: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_depth',
    defaultMessage: '0.7',
  },
  exampleString13: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_string_13',
    defaultMessage: '888462064149',
  },
  exampleInt: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_int',
    defaultMessage: '',
  },
  exampleEan: {
    id: 'bo_seller-options-batch_listing_creation-csv-example_ean',
    defaultMessage: '888462064149',
  },
}
